import {Box, Divider} from '@mui/material';
import styles from '../../../styles/components/clientdetails/projectDrawerStyle.module.scss';

const ProjectSectionDivider = () => {
  return (
    <Box className={`${styles.projectSectionDivider}`}>
      <Divider />
    </Box>
  );
};

export default ProjectSectionDivider;
